

































import { Component, Prop, Mixins } from 'vue-property-decorator'
import { CssStyle } from '@/tcw/domain/types'
import BaseComponent from '@/tcw/components/BaseComponent'
import TcwLayoutBasicHeader from '@/layout/TcwLayoutBasicHeader.vue'
import TcwLayouMobileFooter from '@/layout/TcwLayouMobileFooter.vue'

@Component({
  components: { TcwLayoutBasicHeader, TcwLayouMobileFooter }
})
export default class TcwLayoutBasicTemplate extends Mixins(BaseComponent) {
  @Prop({ type: Boolean, default: true })
  private hasHeader!: boolean
  @Prop({ type: Boolean, default: false })
  private hasLocalHeader!: boolean
  @Prop({ type: Boolean, default: false })
  private hasLocalFooter!: boolean
  @Prop({ type: Boolean, default: true })
  private hasFooter!: boolean

  private height: number = window.innerHeight - 10
  private get headerHeight(): number {
    return this.hasHeader ? 52 : 0
  }
  private get localHeaderHeight(): number {
    return this.hasLocalHeader ? 46 : 0
  }
  private get localFooterHeight(): number {
    return this.hasLocalFooter ? 46 : 0
  }
  private get footerHeight(): number {
    return this.hasFooter && this.isMobile && !this.isFirstLoginFlow ? 64 : 0
  }
  private get contentHeight(): number {
    return this.height - (this.headerHeight + this.footerHeight)
  }

  get templateStyle(): CssStyle {
    return {
      height: `${this.height}px`
    }
  }
  get commonHeaderStyle(): CssStyle {
    return {
      height: `${this.headerHeight}px`
    }
  }
  get contentStyle(): CssStyle {
    return {
      height: `${this.contentHeight}px`
    }
  }
  get localHeadStyle(): CssStyle {
    return {
      height: `${this.localHeaderHeight}px`
    }
  }
  get contentMainStyle(): CssStyle {
    return {
      top: `${this.localHeaderHeight}px`,
      height: `${this.contentHeight - (this.localHeaderHeight + this.localFooterHeight)}px`
    }
  }
  get localFooterStyle(): CssStyle {
    return {
      height: `${this.localFooterHeight}px`
    }
  }
  get footerStyle(): CssStyle {
    return {
      height: `${this.footerHeight}px`
    }
  }

  private mounted() {
    window.addEventListener('resize', this.handleResize)
  }

  private beforeDestroy() {
    window.removeEventListener('resize', this.handleResize)
  }

  private handleResize() {
    this.height = window.innerHeight
  }
}
